import React from 'react';
import { 
  AlertTriangle, CheckCircle, Scale, Zap, List, Sparkles,
  Target, Activity, Users, ShieldAlert, ShieldCheck, 
  BrainCircuit, HeartPulse, Brain, Loader2, Download 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

const DIMENSIONS = [
  { id: "I", title: "Başkalarının Görüşü", max: 8, threshold: 4 },
  { id: "II", title: "Kendi Görüşünüz", max: 7, threshold: 4 },
  { id: "III", title: "Gelecek Endişesi", max: 6, threshold: 3 },
  { id: "IV", title: "Hazırlanmakla İlgili", max: 6, threshold: 3 },
  { id: "V", title: "Bedensel Tepkiler", max: 7, threshold: 4 },
  { id: "VI", title: "Zihinsel Tepkiler", max: 10, threshold: 4 },
  { id: "VII", title: "Genel Sınav Kaygısı", max: 6, threshold: 3 }
];

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const SinavKaygisiReportUI = ({ data, meta }) => {
  const INTERPRETATIONS = [
    {
      id: "I", title: "Başkalarının Görüşü", max: 8, threshold: 4,
      high: "Başkalarının sizi nasıl gördüğü sizin için büyük önem taşıyor. Çevrenizdeki insanların değerlendirmeleri bir sınav durumunda zihinsel faaliyetlerinizi olumsuz etkiliyor ve sınav başarınızı tehlikeye atıyor.",
      low: "Başkalarının sizinle ilgili görüşleri sizin için fazla önem taşımıyor. Bu sebeple sınavlara hazırlanırken çevrenizdeki insanların sizinle ilgili ne düşündükleri üzerinde kafa yorup zaman ve enerji kaybetmiyorsunuz."
    },
    {
      id: "II", title: "Kendi Görüşünüz", max: 7, threshold: 4,
      high: "Sınavlardaki başarınızla kendinize olan saygınızı eşdeğer görüyorsunuz. Sınavlarda ölçülerin kişilik değeriniz olmayıp bilgi düzeyiniz olduğunu kabullenmeniz gerekir. Düşünce biçiminiz problemleri çözmek konusunda size yardımcı olmadığı gibi, endişelerinizi arttırıp elinizi kolunuzu bağlıyor.",
      low: "Sınavlardaki başarınızla kendi kişiliğinize verdiğiniz değeri birbirinden oldukça iyi ayırabildiğiniz anlaşılmaktadır. Bu tutumunuz problemleri daha etkili biçimde çözmenize imkân vermekte okul başarınızı olumlu yönde etkilemektedir."
    },
    {
      id: "III", title: "Gelecek Endişesi", max: 6, threshold: 3,
      high: "Sınavlardaki başarınızı gelecekteki mutluluğunuz ve başarınızın tek ölçüsü olarak görüyorsunuz. Bu yaklaşım biçiminin sonucu olarak sınavların güvenliğiniz ve amaçlarınıza ulaşmanız konusunda engel olduğunu düşünüyorsunuz. Bu düşünceler bilginizi yeterince ortaya koymanızı güçleştiriyor ve başarınızı tehdit ediyor.",
      low: "Gelecekteki mutluluğunuzun, başarınızın ve güvenliğinizin tek belirleyicisinin sınavlardaki başarınız olmadığının farkındasınız. Bu sebeple sınavlara geçilmesi gereken aşamalar olarak bakınız, bilginizi yeterince ortaya koymanıza imkân veriyor."
    },
    {
      id: "IV", title: "Hazırlanmakla İlgili", max: 6, threshold: 3,
      high: "Sınavları konusundaki değeriniz ve gelecekteki güvenliğinizin bir ölçüsü olarak gördüğünüz için herhangi bir sınava hazırlık dönemi sizin için bir kriz dönemi oluyor. Sınavda başarılı olmanızı sağlayacak olan hazırlanma tekniklerinizi öğrenirseniz kendinize güveniniz artacak, endişelerinizi kontrol etmek için önemli bir adım atmış olursunuz.",
      low: "Bir sınava verdiğiniz önem, o sınavın kendi değerinden büyük olmadığı için, sınavlara büyük bir gerginlik hissetmeden hazırlanıyorsunuz. Sınavda başarılı olabilmek için, sınava hazırlanmanın sistemini bilmeniz, gereksiz gerginlikleri yaşamamanıza ve sınava huzurlu bir şekilde çalışarak başarınızın yükselmesine olanak sağlıyor."
    },
    {
      id: "V", title: "Bedensel Tepkiler", max: 7, threshold: 4,
      high: "Bir sınava hazırlanırken iştahsızlık, uykusuzluk, gerginlik gibi bir çok bedensel rahatsızlıkla mücadele etmek zorunda kaldığınız anlaşılmaktadır. Bu rahatsızlıklar sınavla ilgili hazırlığınızı güçleştirmekte ve başarınızı olumsuz yönde etkilemektedir. Bedensel tepkilerinizi kontrol etmeyi başarmanız zihinsel olarak hem hazırlığınızı, hem de sınavda bildiklerinizi ortaya koymanızı kolaylaştıracaktır.",
      low: "Sınava hazırlık sırasında heyecanınızı kontrol edebildiğiniz ve bedensel olarak çalışmanızı zorlaştıracak bir rahatsızlık hissetmediğiniz anlaşılmaktadır."
    },
    {
      id: "VI", title: "Zihinsel Tepkiler", max: 10, threshold: 4,
      high: "Sınava hazırlanırken veya sınav arasında çevrenizde olan bitenden fazlasıyla etkilenmeniz ve dikkatinizi toplamanızda güçlük çekmeniz yüksek sınav kaygısının işaretidir. Bu durum düşünce akışını yavaşlatır ve başarıyı engeller. Zihinsel ve bedensel rahatsızlığınız birbirini körükler ve sınava hazırlığınızı zorlaştırır. Sınavlarda başarılı olabilmek için zihinsel tepkilerinizi kontrol altına almayı öğrenmeniz gerekmektedir.",
      low: "Zihinsel açıdan sınava hazırlanırken veya sınav sırasında önemli bir rahatsızlık yaşamadığınız görülmektedir. Heyecanınızı kontrol etmeniz zihinsel ve duygusal olarak hazırlığınızı kolaylaştırmakta ve başarınızı arttırmaktadır."
    },
    {
      id: "VII", title: "Genel Sınav Kaygısı", max: 6, threshold: 3,
      high: "Sınavlarda kendinize güvenemediğiniz, sınavları varlığınız ve geleceğiniz için bir tehdit olarak gördüğünüz anlaşılmaktadır. Sınavlara sahip oldukları önemin çok üzerinde değer vermekte ve belki de bu sebeple çok fazla heyecanlanmaktasınız. Sınav kaygınızı azaltacak teknikleri öğrenmeniz, hem eğitim başarınızı yükseltecek hem hayattan aldığınız zevki arttıracak, hem de sizi daha etkili bir insan yapacaktır.",
      low: "Sınavları geçilmesi gereken zorunlu engeller olarak görüp hazırlandığınız görülmektedir. Eğitim hayatındaki sınavların hayatın bir parçası olduğunun farkındasınız ve bu tavrınız sınavlara hazırlığınızı kolaylaştırarak eğitim başarınızı olumlu yönde etkilemektedir."
    }
  ];

  const chartData = data.chartData || [];
  
  const mappedResults = INTERPRETATIONS.map((inter, index) => {
    // 🚀 YENİ MOTOR UYUMU: Ham puanı 'rawCount'tan al. Eski raporlar çökmesin diye 'A' fallback'i (??) kullan!
    const score = chartData[index] ? (chartData[index].rawCount ?? chartData[index].A) : 0;
    const isHighRisk = score >= inter.threshold;
    return { ...inter, score, isHighRisk, text: isHighRisk ? inter.high : inter.low };
  });

  const highRiskCount = mappedResults.filter(r => r.isHighRisk).length;
  const isOverallHigh = highRiskCount >= 3;

  const bedensel = mappedResults.find(r => r.id === "V");
  const zihinsel = mappedResults.find(r => r.id === "VI");
  
  const bedenPercent = Math.round((bedensel.score / bedensel.max) * 100);
  const zihinPercent = Math.round((zihinsel.score / zihinsel.max) * 100);

  let teraziText = "";
  let groundingTitle = "";
  let groundingAction = "";

  if (bedenPercent > zihinPercent + 10) {
      teraziText = "Öğrencinin kaygısı ağırlıklı olarak BEDENSEL (Somatik) tepkilerle ortaya çıkıyor. Sınav anında mide bulantısı, çarpıntı veya nefes darlığı yaşama ihtimali yüksek. Zihinsel telkinden ziyade fizyolojik rahatlama tekniklerine ihtiyaç var.";
      groundingTitle = "Acil Topraklama: 4-7-8 Nefes Tekniği";
      groundingAction = "Sınav kağıdı dağıtılırken: İçinden 4'e kadar sayarak nefes al, 7 saniye tut ve 8 saniyede yavaşça ver. Bu işlem kalp ritmini yavaşlatıp parasempatik sinir sistemini (sakinleşme) anında devreye sokacaktır.";
  } else if (zihinPercent > bedenPercent + 10) {
      teraziText = "Öğrencinin kaygısı ağırlıklı olarak ZİHİNSEL (Bilişsel) tepkilerle şekilleniyor. 'Yapamayacağım, unutacağım' gibi felaketleştirici düşünceler zihnini işgal ediyor. Dikkati düşüncelerden çekip dış dünyaya odaklamak şart.";
      groundingTitle = "Acil Topraklama: 5-4-3-2-1 Tekniği";
      groundingAction = "Zihin felaket senaryosu ürettiğinde dur ve etrafına bak: Gördüğün 5 şey, dokunabildiğin 4 şey, duyduğun 3 ses, kokladığın 2 şey ve tattığın 1 şeyi içinden say. Bu zihni 'şu ana' çeker.";
  } else {
      teraziText = "Bedensel ve zihinsel kaygı tepkileri dengeli bir şekilde birbirini tetikliyor. Fiziksel gerginlik olumsuz düşünceleri, olumsuz düşünceler ise fiziksel gerginliği artırıyor (Kısır döngü).";
      groundingTitle = "Acil Topraklama: Taktiksel Odak Değişimi";
      groundingAction = "Sınavda kilitlendiğin an kalemi bırak. Gözlerini kapatıp derin bir nefes al, ardından en kolay bulduğun veya en iyi bildiğin soruya atla. Öz yeterlilik hissini küçük bir doğruyla yeniden tetikle.";
  }

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col">
      {/* ÜST BAŞLIK */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 ${isOverallHigh ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div className="flex items-center gap-4 print:gap-3">
          <div className={`h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner ${isOverallHigh ? 'bg-red-600' : 'bg-slate-700'}`}>
            {isOverallHigh ? <AlertTriangle className="h-6 w-6 print:h-4 print:w-4"/> : <CheckCircle className="h-6 w-6 print:h-4 print:w-4"/>}
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Sınav Kaygısı Analizi</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
              {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className={`text-2xl print:text-xl font-black block leading-none ${isOverallHigh ? 'text-red-300' : 'text-emerald-400'}`}>{highRiskCount}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Riskli Alan</span>
        </div>
      </div>

      {/* SİMETRİK ÜST BÖLGE: TERAZİ VE TOPRAKLAMA KARTLARI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4">
         {/* SOL: BEDEN VS ZİHİN TERAZİSİ */}
         <div className="bg-indigo-50 p-5 print:p-4 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-indigo-200 pb-3 print:pb-2 print:border-slate-200">
             <Scale className="h-5 w-5 print:h-4 print:w-4 text-indigo-600 mr-3 print:mr-2"/>
             <div>
               <span className="text-xs print:text-[10.5px] font-black text-indigo-900 uppercase tracking-widest block leading-none">Beden vs. Zihin Terazisi</span>
               <span className="text-[9px] print:text-[8px] font-medium text-indigo-600 uppercase tracking-wide mt-0.5 block">Kaygının Merkez Üssü</span>
             </div>
           </div>
           
           <div className="flex items-center justify-between mb-2 mt-1">
               <div className="text-center w-16 print:w-14">
                   <span className="block text-[10px] print:text-[8px] font-bold text-slate-500 leading-tight">ZİHİNSEL<br/>(Bilişsel)</span>
                   <span className="text-lg print:text-sm font-black text-purple-600">%{zihinPercent}</span>
               </div>
               <div className="flex-1 px-4 print:px-3 flex items-center">
                   {/* YENİ: flex-1 yerine oranları doğrudan flex değerine veriyoruz! */}
                   <div className="h-2 print:h-1.5 bg-purple-500 rounded-l-full print:bg-slate-700 opacity-90" style={{ flex: zihinPercent || 1 }}></div>
                   <div className="h-2 print:h-1.5 bg-teal-400 rounded-r-full print:bg-slate-300 opacity-90" style={{ flex: bedenPercent || 1 }}></div>
               </div>
               <div className="text-center w-16 print:w-14">
                   <span className="block text-[10px] print:text-[8px] font-bold text-slate-500 leading-tight">BEDENSEL<br/>(Somatik)</span>
                   <span className="text-lg print:text-sm font-black text-teal-600">%{bedenPercent}</span>
               </div>
           </div>
           
           <p className="text-[11px] print:text-[10.5px] text-slate-700 leading-snug font-medium mt-1.5 text-justify">
             {teraziText}
           </p>
         </div>

         {/* SAĞ: ACİL TOPRAKLAMA AKSİYONU */}
         <div className="bg-emerald-50 p-5 print:p-4 rounded-2xl border border-emerald-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm relative overflow-hidden">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-emerald-200 pb-3 print:pb-2 print:border-slate-200 opacity-90">
             <Zap className="h-5 w-5 print:h-4 print:w-4 mr-3 print:mr-2 text-emerald-600"/>
             <span className="text-xs print:text-[10.5px] font-black uppercase tracking-widest text-emerald-800">Pratik Müdahale Reçetesi</span>
           </div>
           
           <h3 className="text-sm print:text-[12px] font-black mb-1.5 leading-tight text-emerald-900">
             {groundingTitle}
           </h3>
           <p className="text-[11.5px] print:text-[10.5px] text-slate-800 leading-snug font-medium text-justify">
             {groundingAction}
           </p>
         </div>
      </div>

      {/* ALT KISIM: 7 BOYUTLU DİNAMİK YORUM KARTLARI */}
      <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none mt-2 print:mt-3 flex-1">
        <h3 className="font-bold text-slate-800 mb-4 print:mb-3 flex items-center text-sm print:text-xs border-b pb-3 print:pb-2">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Boyut Bazlı Profil Yorumları
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-3">
          {mappedResults.map((item, i) => (
            <div key={i} className={`p-4 print:p-3 rounded-xl border shadow-sm transition-all print:shadow-none ${item.isHighRisk ? 'bg-red-50/30 border-red-200 print:border-slate-300' : 'bg-white border-slate-200 print:border-slate-200'}`}>
              
              <div className="flex justify-between items-center mb-3 print:mb-1.5">
                <div className="flex items-center">
                  <div className={`min-w-[24px] h-6 print:min-w-[18px] print:h-4 rounded flex items-center justify-center text-[10px] print:text-[8px] font-black mr-3 print:mr-2 border ${item.isHighRisk ? 'bg-red-100 text-red-700 border-red-200' : 'bg-slate-100 text-slate-600 border-slate-200'}`}>
                    {item.id}
                  </div>
                  <h4 className="font-bold text-slate-800 text-sm print:text-[11px] leading-none">{item.title}</h4>
                </div>
                <div className={`text-xs print:text-[9.5px] font-black ${item.isHighRisk ? 'text-red-600' : 'text-slate-600'}`}>
                  {item.score} <span className="text-[10px] print:text-[8px] text-slate-400 font-medium">/ {item.max}</span>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="h-1.5 print:h-1 w-full bg-slate-100 rounded-full overflow-hidden mb-3 print:mb-1.5 print:border print:border-slate-200">
                <div className={`h-full rounded-full print:bg-slate-700 ${item.isHighRisk ? 'bg-red-500' : 'bg-emerald-500'}`} style={{width: `${(item.score / item.max) * 100}%`}}></div>
              </div>

              <p className="text-[11px] print:text-[9.5px] text-slate-700 font-medium leading-relaxed print:leading-tight text-justify">
                {item.text}
              </p>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateSinavKaygisi = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  let redAlarmStudents = 0;
  let totalHighRiskAreas = 0;
  
  // Boyut bazlı riskli öğrenci sayacı
  const dimensionRiskCounts = { I: 0, II: 0, III: 0, IV: 0, V: 0, VI: 0, VII: 0 };
  
  // Beden/Zihin ortalamaları için toplamlar
  let totalBedenPercent = 0;
  let totalZihinPercent = 0;

  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || s.studentInfo?.class || s.reportData?.studentInfo?.sinif || "Tüm Sınıflar";
    
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, highRiskStudentCount: 0 };
    }
    classMap[className].studentCount++;

    const chartData = s.chartData || s.reportData?.chartData || [];
    let studentHighRiskCount = 0;

    DIMENSIONS.forEach((dim, index) => {
      // 🚀 YENİ MOTOR UYUMU: Kurumsal motor da 'A' (yüzde) ile değil, 'rawCount' (ham puan) ile çalışmalı!
      const score = chartData[index] ? (chartData[index].rawCount ?? chartData[index].A) : 0;
      
      if (score >= dim.threshold) {
        studentHighRiskCount++;
        dimensionRiskCounts[dim.id]++;
      }
      
      // Beden (V) ve Zihin (VI) yüzdelerini topla
      if (dim.id === "V") totalBedenPercent += (score / dim.max) * 100;
      if (dim.id === "VI") totalZihinPercent += (score / dim.max) * 100;
    });

    totalHighRiskAreas += studentHighRiskCount;

    // Genel riskli öğrenci tanımı (En az 3 alanda yüksek risk)
    if (studentHighRiskCount >= 3) {
      redAlarmStudents++;
      classMap[className].highRiskStudentCount++;
    }
  });

  const avgBedenPercent = Math.round(totalBedenPercent / total);
  const avgZihinPercent = Math.round(totalZihinPercent / total);

  const sortedDimensions = DIMENSIONS.map(dim => ({
    ...dim,
    riskCount: dimensionRiskCounts[dim.id],
    riskPercent: Math.round((dimensionRiskCounts[dim.id] / total) * 100)
  })).sort((a, b) => b.riskCount - a.riskCount);

  const dominantDimension = sortedDimensions[0];
  const avgRiskAreasPerStudent = total > 0 ? (totalHighRiskAreas / total).toFixed(1) : 0;

  const classStats = Object.values(classMap).map(c => ({
    ...c,
    riskIntensity: c.studentCount > 0 ? Math.round((c.highRiskStudentCount / c.studentCount) * 100) : 0
  })).sort((a, b) => b.riskIntensity - a.riskIntensity);

  return { total, redAlarmStudents, dominantDimension, sortedDimensions, avgBedenPercent, avgZihinPercent, avgRiskAreasPerStudent, classStats };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const SinavKaygisiKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateSinavKaygisi(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm = data.redAlarmStudents > 0;
  const redAlarmPercent = data.total > 0 ? Math.round((data.redAlarmStudents / data.total) * 100) : 0;

  let teraziText = "";
  if (data.avgBedenPercent > data.avgZihinPercent + 10) {
    teraziText = "Kurumdaki öğrencilerin kaygısı ağırlıklı olarak BEDENSEL (Somatik) tepkilerle (çarpıntı, mide bulantısı) ortaya çıkmaktadır. Topraklama ve nefes egzersizlerine ağırlık verilmelidir.";
  } else if (data.avgZihinPercent > data.avgBedenPercent + 10) {
    teraziText = "Kurumdaki öğrencilerin kaygısı ağırlıklı olarak ZİHİNSEL (Bilişsel) tepkilerle (felaket senaryoları, unutma korkusu) şekillenmektedir. Bilişsel yeniden yapılandırma şarttır.";
  } else {
    teraziText = "Kurumdaki öğrencilerin bedensel ve zihinsel kaygı tepkileri birbirini dengeli şekilde tetiklemektedir. Hem fiziksel rahatlama hem de bilişsel müdahaleler eşzamanlı yürütülmelidir.";
  }

  let quickAction = "Öğrencilere sınavın bir kişilik testi değil, bilgi ölçümü olduğu vurgulanmalıdır.";
  if(data.dominantDimension.id === "I") quickAction = "Öğrencilerin 'Başkaları ne der?' baskısını azaltmak için veli ve öğretmenlerin sınav dilini (beklenti cümlelerini) değiştirmesi gerekmektedir.";
  else if(data.dominantDimension.id === "III") quickAction = "Öğrencilerin sınavı 'hayatın tek gerçeği' olarak görmesini engellemek için alternatif kariyer yolları ve mesleki rehberlik çalışmaları artırılmalıdır.";
  else if(data.dominantDimension.id === "IV") quickAction = "Sorun kaygıdan ziyade 'nasıl çalışılacağını bilmemekten' kaynaklanıyor. Acilen zaman yönetimi ve verimli ders çalışma seminerleri verilmelidir.";

  const pdrModelObj = isRedAlarm ? {
      type: 'Krize Müdahale / İyileştirici Model',
      color: 'text-red-700',
      icon: ShieldAlert,
      iconColor: 'text-red-600',
      desc: "Kritik gruptaki öğrenciler için ivedilikle duygu regülasyonu ve bireysel psikolojik destek planlanmalıdır.",
      bullets: [
          `Acil Durum: ${data.redAlarmStudents} öğrenciyle birebir klinik ön görüşme.`,
          "Veli Teması: Kaygı tetikleyicileri üzerine ebeveyn bilgilendirmesi.",
          "İzleme: Haftalık periyotlarla somatik/bilişsel stres takibi."
      ]
  } : {
      type: 'Önleyici / Gelişimsel Model',
      color: 'text-emerald-700',
      icon: ShieldCheck,
      iconColor: 'text-emerald-600',
      desc: "Kurum geneli için rutin sınav kaygısı ve motivasyon seminerleri yeterli görülmektedir.",
      bullets: [
          "Odak: Sınav stratejileri ve zaman yönetimi becerilerinin kazandırılması.",
          "Grup Çalışması: Sınıf içi nefes ve gevşeme egzersizleri atölyesi.",
          "İzleme: Aylık rutin akademik motivasyon ölçümleri."
      ]
  };

  let barrierObj = {};
  if (data.dominantDimension.id === "V") {
      barrierObj = {
          title: "Sınav Anı Somatik (Bedensel) Blokaj",
          desc: "Fizyolojik uyarılma, bilişsel işlevleri dondurarak 'bildiklerini unutmalara' (Blackout) yol açmaktadır.",
          bullets: [
              "Sınav anında yoğun çarpıntı, terleme veya mide bulantısı.",
              "Bilginin değil, bedensel paniğin yönetilememesi sorunu.",
              "İhtiyaç: Sınav esnası topraklama (grounding) teknikleri."
          ]
      };
  } else if (data.dominantDimension.id === "IV") {
      barrierObj = {
          title: "Sistem ve Strateji Eksikliği",
          desc: "Masaya oturma direnci ve plansızlık, son dakika paniğini ve akademik ertelemeyi tetiklemektedir.",
          bullets: [
              "Nasıl çalışılacağını veya zamanı nasıl yöneteceğini bilememe.",
              "Çalışma yığılması sebebiyle oluşan sahte (ikincil) kaygı durumu.",
              "İhtiyaç: Pomodoro ve bireyselleştirilmiş haftalık planlar."
          ]
      };
  } else if (data.dominantDimension.id === "I") {
      barrierObj = {
          title: "Sosyal Baskı ve Özgüven Kaybı",
          desc: "Aile ve çevre beklentileri altında ezilme korkusu, potansiyelin tam olarak yansıtılmasını engeller.",
          bullets: [
              "Sınavı bilgi ölçümü değil, 'kişilik/değer testi' olarak algılama.",
              "Başkalarının ne düşüneceği korkusuyla soruya odaklanamama.",
              "İhtiyaç: Sonuç odaklı değil, çaba odaklı bir okul/veli dili."
          ]
      };
  } else {
      barrierObj = {
          title: "Odak Kaybı ve Bilişsel Çarpıtma",
          desc: "Aşırı düşünme (overthinking) hali, derse başlama süresini uzatmakta ve ertelemeyi beslemektedir.",
          bullets: [
              "'Yapamayacağım, kötü olacak' tarzı felaketleştirici senaryolar.",
              "Olumsuz iç ses nedeniyle akademik öz-yeterlilik hissinin çökmesi.",
              "İhtiyaç: Bilişsel yeniden yapılandırma ve küçük adım hedefleri."
          ]
      };
  }

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('sinav-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="sinav-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - YÖNETİCİ ÖZETİ VİTRİNİ            */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Activity className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   SINAV KAYGISI ÖLÇEĞİ • KURUMSAL RİSK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-emerald-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-emerald-600'}`}>Kritik Kaygı Grubu</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-emerald-700'}`}>
                 {data.redAlarmStudents} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{redAlarmPercent})</span>
              </p>
            </div>
            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Baskın Tetikleyici</span>
              </div>
              <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight truncate">{data.dominantDimension.title}</p>
            </div>
            <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Activity className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>
                 <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">Risk Alanı Yükü</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">
                 {data.avgRiskAreasPerStudent} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Alan/Kişi</span>
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> En Kaygılı Kademeler
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Grup</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">(%{data.classStats[0].riskIntensity} Kriz)</span>}
                    </p>
                  </div>
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Grup</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'Diğer Gruplar Normal'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">(%{data.classStats[1].riskIntensity} Kriz)</span>}
                    </p>
                  </div>
               </div>
            </div>

            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Scale className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Kurumsal Kaygı Profili
               </h3>
               
               <div className="flex items-center justify-between mb-1.5 mt-1">
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">ZİHİNSEL<br/>(Bilişsel)</span>
                       <span className="text-base print:text-[11px] font-black text-purple-700">%{data.avgZihinPercent}</span>
                   </div>
                   <div className="flex-1 px-3 print:px-2 flex items-center">
                       <div className="h-2.5 print:h-1.5 flex-1 bg-purple-500 rounded-l-full print:bg-slate-700"></div>
                       <div className="h-2.5 print:h-1.5 flex-1 bg-teal-400 rounded-r-full print:bg-slate-300"></div>
                   </div>
                   <div className="text-center w-14 print:w-12">
                       <span className="block text-[10px] print:text-[7.5px] font-bold text-slate-500 leading-tight mb-0.5">BEDENSEL<br/>(Somatik)</span>
                       <span className="text-base print:text-[11px] font-black text-teal-700">%{data.avgBedenPercent}</span>
                   </div>
               </div>
               
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-1 text-justify line-clamp-3">
                 {teraziText}
               </p>
            </div>

            <div className="col-span-2 bg-amber-50 p-4 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex items-center gap-3">
               <div className="shrink-0 bg-amber-100 print:bg-slate-100 p-2.5 print:p-2 rounded-xl">
                 <Zap className="h-6 w-6 print:h-4 print:w-4 text-amber-600"/>
               </div>
               <div>
                 <h3 className="font-bold text-amber-900 text-xs print:text-[10px] uppercase tracking-widest mb-1">Kurumsal Hızlı Kazanım Stratejisi</h3>
                 <p className="text-sm print:text-[10.5px] font-medium text-amber-900 print:text-slate-800 leading-tight">
                   {quickAction}
                 </p>
               </div>
            </div>

            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <List className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Okulu Aşağı Çeken 4 Ana Kaygı Boyutu
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Yüksek Riskli Öğrenci Oranı</span>
               </div>
               
               <div className="space-y-3 print:space-y-2">
                  {data.sortedDimensions.slice(0, 4).map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.title}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.riskPercent} <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">({dim.riskCount} Kişi)</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className="h-full rounded-full bg-slate-600 print:bg-slate-500" style={{ width: `${dim.riskPercent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className="col-span-1 bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 flex flex-col shadow-sm print:shadow-none print:min-h-[140px]">
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <pdrModelObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${pdrModelObj.iconColor}`}/>
                  Önerilen PDR Modeli
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${pdrModelObj.color}`}>
                      {pdrModelObj.type}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {pdrModelObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {pdrModelObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${pdrModelObj.iconColor}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             <div className="col-span-1 bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 flex flex-col shadow-sm print:shadow-none print:min-h-[140px]">
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <BrainCircuit className="h-5 w-5 print:h-4 print:w-4 mr-2 text-blue-600"/> Akademik Performans Bariyeri
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className="text-sm print:text-[11px] font-black text-blue-700 leading-tight mb-1.5">
                      {barrierObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {barrierObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {barrierObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className="mr-1.5 font-black text-blue-600">•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Sınav Kaygısı Müdahale Eylem Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.sortedDimensions.slice(0, 5))} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-10 pt-4 text-[10px] text-black px-12 shrink-0 border-t border-slate-300">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-16">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-16">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};